import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

import ProductSearch from "./SearchResult/ProductSearch";
import CategorySearch from "./SearchResult/CategorySearch";
import CollectionSearch from "./SearchResult/CollectionSearch";

export default function SearchResult() {
    const [categoryIsEmpty, setCategoryIsEmpty] = useState(false);
    const [collectionIsEmpty, setCollectionIsEmpty] = useState(false);
    // const [productIsEmpty, setProductIsEmpty] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();

    // const { keywords } = useContext(MainContext);

    // const [isKeywordResults, setIsKeywordResults] = useState(false);

    const search = searchParams.get("q")?.split("\\").join("\\\\");

    return (
        <>
            <h1>Website Search</h1>
            {search && search.length !== 0 ? (
                <>
                    {/* {keywords && (
                        <>
                            {isKeywordResults && (
                                <>
                                    <h1>Keywords Search</h1>
                                    <Divider className="mb-5" />
                                </>
                            )}
                            {keywords.map((collection) => {
                                {
                                    let keywordFilter = "";
                                    collection.attributes.keywords.data.map(
                                        (k) => {
                                            keywordFilter += `{ title: { containsi: \"${k.attributes.keyword}\" } }\n`;
                                        }
                                    );

                                    if (keywordFilter.length !== 0)
                                        if (!isKeywordResults)
                                            setIsKeywordResults(true);
                                    return (
                                        keywordFilter.length !== 0 && (
                                            <KeywordSearchResult
                                                key={collection.id}
                                                collectionName={
                                                    collection.attributes.name
                                                }
                                                keywords={
                                                    collection.attributes
                                                        .keywords
                                                }
                                                keywordFilter={keywordFilter}
                                            />
                                        )
                                    );
                                }
                            })}
                        </>
                    )} */}
                    {categoryIsEmpty && collectionIsEmpty && (
                        <p>Sorry, the search returned no results.</p>
                    )}
                    {/* if you want to uncomment the method, keep in mind that in
                    the Collection entity there was a Keywords field - a
                    relation, and in Keywords there was an as_part_of field -
                    also a relation (both many-to-many relations) */}
                    {/* <ProductSearch
                        search={search}
                        isEmpty={productIsEmpty}
                        onEmptySearch={() => setProductIsEmpty(true)}
                    />*/}
                    <CategorySearch
                        search={search}
                        isEmpty={categoryIsEmpty}
                        onEmptySearch={() => setCategoryIsEmpty(true)}
                    />
                    <CollectionSearch
                        search={search}
                        isEmpty={collectionIsEmpty}
                        onEmptySearch={() => setCollectionIsEmpty(true)}
                    />
                </>
            ) : (
                <p>Please type your text in the search box</p>
            )}
        </>
    );
}
